import { ATTACHMENT_DOWNLOAD_MODE } from '../../../ui/molecules/AttachmentModal';
import { getAiTokenSurface } from '../services/aiTokenApi';
// ---------------------------------------------------------------------------
// Which way the attachment modal's Download starts a download in THIS environment (B47).
//
//  - iOS app webview (`surface === 'ios_webview'`): `native`. The host's navigation delegate
//    handles links and downloads itself, so the link stays exactly what it was: plain, no
//    `download` attribute, nothing intercepted.
//  - an iOS / iPadOS browser (Safari, and every other browser there: they are all WebKit):
//    `programmatic`. A plain link to a PDF can navigate the whole tab to it, so the click is
//    intercepted and the download is started by clicking a hidden anchor with `download`.
//  - everything else (desktop, Android, the technician portal on a laptop): `link`, the same link
//    with the `download` attribute added.
// ---------------------------------------------------------------------------
const IOS_WEBVIEW_SURFACE = 'ios_webview';
const IOS_DEVICE_PATTERN = /iPad|iPhone|iPod/;
/** iPadOS 13+ Safari reports a desktop Mac platform; what gives it away is the touch screen. */
const IPADOS_DESKTOP_PLATFORM = 'MacIntel';
const MULTI_TOUCH_MIN_POINTS = 2;
function currentEnvironment() {
    var _a, _b, _c;
    const nav = typeof navigator === 'undefined' ? undefined : navigator;
    return {
        userAgent: (_a = nav === null || nav === void 0 ? void 0 : nav.userAgent) !== null && _a !== void 0 ? _a : '',
        platform: (_b = nav === null || nav === void 0 ? void 0 : nav.platform) !== null && _b !== void 0 ? _b : '',
        maxTouchPoints: (_c = nav === null || nav === void 0 ? void 0 : nav.maxTouchPoints) !== null && _c !== void 0 ? _c : 0,
        surface: getAiTokenSurface()
    };
}
/** True for any browser on an iPhone, iPod or iPad (including iPadOS presenting as a Mac). */
export function isIosBrowser(env) {
    return (IOS_DEVICE_PATTERN.test(env.userAgent) ||
        (env.platform === IPADOS_DESKTOP_PLATFORM && env.maxTouchPoints >= MULTI_TOUCH_MIN_POINTS));
}
export function resolveAttachmentDownloadMode(env = currentEnvironment()) {
    if (env.surface === IOS_WEBVIEW_SURFACE)
        return ATTACHMENT_DOWNLOAD_MODE.NATIVE;
    return isIosBrowser(env) ? ATTACHMENT_DOWNLOAD_MODE.PROGRAMMATIC : ATTACHMENT_DOWNLOAD_MODE.LINK;
}
